import { getDiscountPercent, getDiscountPrice } from './discountUtils';
import { getItemPriceWithDiscount } from './lib/totalPriceHelpers';
import { CartStore } from './model';
import type { DiscountThreshold } from './discountConfig';

const cartStoreSelectors = {
  googleProfile: (store: CartStore) => store.googleProfile,

  hydrated: (store: CartStore) => store.hydrated,
  items: (store: CartStore) => store.items,
  itemSlugs: (store: CartStore) => store.items.map((item) => item.slug),
  itemBySlug: (slug: string) => (store: CartStore) =>
    store.items.find((item) => item.slug === slug),
  itemQuantityBySlug: (slug: string) => (store: CartStore) => {
    const item = store.items.find((item) => item.slug === slug);
    return item ? item.quantity : 0;
  },
  itemPriceWithDiscount: (slug: string) => (store: CartStore) => {
    const item = store.items.find((i) => i.slug === slug);

    if (!item)
      return {
        price: 0,
        discountedPrice: 0,
        discountDescription: '',
        discountPercent: 0,
        appliedRule: undefined,
        appliedThreshold: undefined as DiscountThreshold | undefined,
        discountPrice: 0,
      };

    return getItemPriceWithDiscount(item);
  },

  itemsCount: (store: CartStore) => store.items.length,
  isEmpty: (store: CartStore) => store.items.length === 0,
  totalQuantity: (store: CartStore) =>
    store.items.reduce((total, item) => total + item.quantity, 0),
  totalPrice: (store: CartStore) => {
    const raw = store.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const withDiscount = store.items.reduce((sum, item) => {
      const { slug, quantity, quantityDiscounts, price } = item;
      const discountPercent = getDiscountPercent(slug, quantity, quantityDiscounts);
      const discountPrice = getDiscountPrice(slug, quantity, quantityDiscounts);

      const discountedPrice =
        discountPrice > 0 ? discountPrice : price * (1 - discountPercent / 100) * quantity;

      return sum + discountedPrice;
    }, 0);

    return {
      raw,
      withDiscount,
      savings: raw - withDiscount,
    };
  },
};

export { cartStoreSelectors };
